import React from "react";
import { useSelector } from "react-redux";
import { toLocalDateTimeMin } from "../../../../../shared/utils/dateUtils";
import Popup from "../../../ui/popup/Popup";
import HeaderPopup from "../../../ui/popup/headerPopup/HeaderPopup";
import ContentsPopup from "../../../ui/popup/contentPopup/ContentPopup";
import SecondaryBtn from "../../../ui/buttons/SecondaryBtn";
import PrimaryBtn from "../../../ui/buttons/PrimaryBtn";
import MessageRichTextEditor, { hasMessageContentError } from "../messageRichTextEditor/MessageRichTextEditor";
import ImageUpload from "../../../ui/imageUpload/ImageUpload";
import ScheduleFields, { hasScheduleFieldsError } from "../../../ui/scheduleFields/ScheduleFields";
import MessageStudyGroupSelect from "../messageStudyGroupSelect/MessageStudyGroupSelect";
import AudienceField from "../../../ui/audienceField/AudienceField";
import classes from "./MessageEditorPopup.module.css";

const MessageEditorPopup = ({
    titleText, publishText, draft, onDraftChange, onClose, onPublish,
    maxContentLength = 100, studyGroups, homeroomClass = false, isSubmitting = false,
    useAudienceField,  popupHeight,
}) => {

    const { texts } = useSelector((state) => state.translate);
    const setField = (patch) => onDraftChange(patch);

    const handlePublish = () => {
        if (hasMessageContentError(draft?.content, maxContentLength) || hasScheduleFieldsError(draft?.fromDate, draft?.toDate))
            return;
        onPublish?.();
    };

    return (
        <Popup close={onClose} title={titleText} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose} style={popupHeight ? { height: popupHeight } : undefined}>
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{titleText}</p>
            </HeaderPopup>
            <ContentsPopup className={classes.ContentsPopup} scrollDropClass={classes.ScrollVisible}>
                <div className={classes.Form}>
                    <MessageRichTextEditor value={draft?.content ?? ""} onChange={(html) => setField({ content: html })} maxLength={maxContentLength} />
                    <div className={classes.MessageImageUploadArea}>
                        <ImageUpload imageFile={draft?.imageFile ?? null} onImageChange={(file) => setField({ imageFile: file })} removeAriaLabel={texts.removeMessageImage} />
                    </div>
                    {useAudienceField
                        ? <AudienceField value={draft?.targetAudience} selectedGrades={draft?.selectedGrades} onChange={(v) => setField({ targetAudience: v })} onGradesChange={(v) => setField({ selectedGrades: v })} />
                        : <MessageStudyGroupSelect studyGroups={studyGroups} studyGroupId={draft?.studyGroupId} onStudyGroupChange={(sg) => setField({ studyGroupId: sg })} homeroomClass={homeroomClass} />
                    }
                    <ScheduleFields fromDate={draft?.fromDate} toDate={draft?.toDate} onFromDateChange={(d) => setField({ fromDate: d })} onToDateChange={(d) => setField({ toDate: d })} minFromDate={toLocalDateTimeMin(new Date())} />
                    {/* {showImportant && <ImportantCheckbox checked={draft?.isImportant} onChange={(v) => setField({ isImportant: v })} />} */}
                </div>
            </ContentsPopup>
            <div className={classes.Footer}>
                <SecondaryBtn color="var(--color-primary-button)" dropClass={classes.CancelBtn} xsmall={true} onClick={onClose}>
                    {texts.cancel}
                </SecondaryBtn>
                <PrimaryBtn dropClass={`${classes.PublishBtn} ${isSubmitting ? classes.PublishBtnDisabled : ""}`} xsmall={true} onClick={handlePublish} isBtn={!isSubmitting}>
                    {isSubmitting ? texts.loadingPublishing : publishText}
                </PrimaryBtn>
            </div>
        </Popup>
    );
};

export default MessageEditorPopup;
